import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NouisliderModule } from 'ng2-nouislider';
import { TagInputModule } from 'ngx-chips';
// import { AppModule } from '../app.module';

import { Status } from '../pipes/status.pipe';
import { Terms } from '../pipes/terms.pipe';
import { Warranty } from '../pipes/warranty.pipe';
import { Priority } from '../pipes/priority.pipe';

import { ProcessingInstructionsRoutes } from './processing-instructions.routing';
import { MaterialModule } from '../app.module';
import { ProcessingInstructionsComponent } from './processing-instructions.component';
import { ProcessingInstructionsCrudComponent, ChangeLocation} from './processing-instructions-crud/processing-instructions-crud.component';
import { ProcessingInstructionsDetailComponent, ChangeLocation1  } from './processing-instructions-detail/processing-instructions-detail.component';
import { CreatePiComponent } from './create-pi/create-pi.component';
import { WeightTableComponent } from './weight-table/weight-table.component';

import { SharedModule } from '../shared/shared.module';
// import { TableTrakingComponent } from '../shared/components/table-traking/table-traking.component';
import { ComponentsModule } from '../shared/components/components.module';
import { PhysicalReportComponent } from './physical-report/physical-report.component';
import { ProgressComponent } from './progress/progress.component';
import { TicketsComponent } from './tickets/tickets.component';
import { TableTicketsComponent } from './tickets/table-tickets/table-tickets.component';
import { TableItemsComponent } from './tickets/table-items/table-items.component';
import { TableManifestItemsComponent } from './tickets/table-manifest-items/table-manifest-items.component';
import { TableScrapsComponent } from './tickets/table-scraps/table-scraps.component'
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from "@angular/material/form-field";

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { CloseModalDirective } from './processing-instructions-detail/close-modal.directive';

@NgModule({
    imports: [
    SharedModule,
        CommonModule,
        RouterModule.forChild(ProcessingInstructionsRoutes),
        FormsModule,
        ReactiveFormsModule,
    NouisliderModule,
    TagInputModule,
    MaterialModule,
    ComponentsModule,
    MatFormFieldModule,
    MatInputModule,
    NgxSkeletonLoaderModule
    ],
    declarations: [
        ProcessingInstructionsComponent,
        ProcessingInstructionsCrudComponent,
        ProcessingInstructionsDetailComponent,
        CreatePiComponent,
        Status,
        Terms,
        Warranty,
        Priority,
        WeightTableComponent,
        // TableTrakingComponent,
        ChangeLocation,
        ChangeLocation1,
        PhysicalReportComponent,
        ProgressComponent,
        TicketsComponent,
        TableTicketsComponent,
        TableItemsComponent,
        TableManifestItemsComponent,
        TableScrapsComponent,
        CloseModalDirective
    ],
    entryComponents: [ProcessingInstructionsComponent, ChangeLocation, ChangeLocation1,  CreatePiComponent],
    exports: [ProcessingInstructionsCrudComponent, ProcessingInstructionsDetailComponent, ChangeLocation, TableItemsComponent, TableManifestItemsComponent, CreatePiComponent,PhysicalReportComponent]
})

export class ProcessignInstructionsModule {}